﻿//require css
//require('font-awesome.css');
require('styles.css');
require('agen-color-9.css');
require('landingPage.css');

var $ = require('jquery');
//require('bootstrap');
require('customModernizr');
require('jquery.easing.1.3');
require('parallax');
require('jquery.masonry');
require('waypoints');
require('retina');
//require('jquery.autoellipsis-1.0.10');
//require('jquery.dotdotdot');

$(document).ready(function () {

    /*============================================
	Page Preloader
	==============================================*/

    $('#page-loader span').animate({ 'width': '100%' }, 10000);

    $(window).load(function () {
        $('#page-loader span').stop().animate({ 'width': '100%' }, 500, function () {
            $('#page-loader').fadeOut(500);
        });

    });


  
    /*============================================
	Navigation Functions
	==============================================*/
    if ($(window).scrollTop() < 10) {
        $('#main-nav').removeClass('is-sticky');
    }
    else {
        $('#main-nav').addClass('is-sticky');
    }

    $(window).scroll(function () {
        if ($(window).scrollTop() < 10) {
            $('#main-nav').removeClass('is-sticky');
        }
        else {
            $('#main-nav').addClass('is-sticky');
        }
    });

    /*============================================
	ScrollTo Links
	==============================================*/
    $('a.scrollto').click(function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        $('html, body').stop().animate({ scrollTop: $(target).offset().top }, 1600, 'easeInOutExpo',
			function () { window.location.hash = target; });

        if ($('.navbar-collapse').hasClass('in')) {
            $('.navbar-collapse').removeClass('in').addClass('collapse');
        }
    });


   

   

    /*============================================
	Placeholder Detection
	==============================================*/
    if (!Modernizr.input.placeholder) {
        $('html').addClass('no-placeholder');
    }

 
    /*============================================
	Resize Functions
	==============================================*/
    $(window).resize(function () {

        if ($('#projects-container').length) {
            $('#projects-container').masonry('reload');
        }

        scrollSpyRefresh();
        waypointsRefresh();

    });

    /*============================================
	Refresh scrollSpy function
	==============================================*/
    function scrollSpyRefresh() {
        setTimeout(function () {
            $('body').scrollspy('refresh');
        }, 1000);

    }

    /*============================================
	Refresh waypoints function
	==============================================*/
    function waypointsRefresh() {
        setTimeout(function () {
            $.waypoints('refresh');
        }, 1000);
    }

    /*============================================
	Contact Form
	==============================================*/
    $('#contact-form').submit(function () {

        if ($('#contact-form').hasClass('clicked')) {
            return false;
        }

        $('#contact-form').addClass('clicked');

        var buttonCopy = $('#contact-form button').html(),
			errorMessage = $('#contact-form button').data('error-message'),
			sendingMessage = $('#contact-form button').data('sending-message'),
			okMessage = $('#contact-form button').data('ok-message'),
			hasError = false;

        $('#contact-form .error-message').remove();

        $('.requiredField').each(function () {
            if ($.trim($(this).val()) == '') {
                var errorText = $(this).data('error-empty');
                $(this).parents('.controls').append('<span class="error-message" style="display:none;">' + errorText + '.</span>').find('.error-message').fadeIn('fast');
                $(this).addClass('inputError');
                hasError = true;
            } else if ($(this).is("input[type='email']") || $(this).attr('name') === 'email') {
                var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
                if (!emailReg.test($.trim($(this).val()))) {
                    var invalidEmail = $(this).data('error-invalid');
                    $(this).parents('.controls').append('<span class="error-message" style="display:none;">' + invalidEmail + '.</span>').find('.error-message').fadeIn('fast');
                    $(this).addClass('inputError');
                    hasError = true;
                }
            }
        });

        if (hasError) {
            $('#contact-form button').html('<i class="fa fa-times"></i>' + errorMessage);
            setTimeout(function () {
                $('#contact-form button').html(buttonCopy);
                $('#contact-form').removeClass('clicked');
            }, 2000);
        }
        else {
            $('#contact-form button').html('<i class="fa fa-spinner fa-spin"></i>' + sendingMessage);

            var formInput = $(this).serialize();
            $.post($(this).attr('action'), formInput, function (data) {
                $('#contact-form button').html('<i class="fa fa-check"></i>' + okMessage);
                setTimeout(function () {
                    $('#contact-form button').html(buttonCopy);
                    $('#contact-form').removeClass('clicked');
                }, 2000);

                $('#contact-form')[0].reset();
            }).fail(function () {
                $('#contact-form button').html('<i class="fa fa-exclamation-triangle"></i> Oops something went wrong.');
                setTimeout(function () {
                    $('#contact-form button').html(buttonCopy);
                    $('#contact-form').removeClass('clicked');
                }, 2000);
            });
        }

        return false;
    });

    //$('#myMissionText, #myApproachText, #mySpecialtyText').ellipsis({ live: true });
    //$('#myMissionText, #myApproachText, #mySpecialtyText').dotdotdot({
    //    watch: true

    //});

    //google maps
    var mapPoint = {
        'lat': 41.184315,
        'lng': -74.061070,
        'zoom': 16,
        'mapAddress': '9 Emerald Dr, Pomona, NY 10970'
    };



    function initMap() {
        var pointLatLng = new google.maps.LatLng(mapPoint.lat, mapPoint.lng);
        var mapstyles = [{ "stylers": [{ "saturation": -100 }] }];
        var isDraggable = $('html').is('.touch') ? false : true;

        var mapOptions = {
            zoom: mapPoint.zoom,
            center: pointLatLng,
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.LARGE,
                position: google.maps.ControlPosition.LEFT_CENTER
            },
            panControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            overviewMapControl: false,
            scrollwheel: false,
            draggable: isDraggable,
            styles: mapstyles
        }

        var map = new google.maps.Map(document.getElementById('gmap'), mapOptions);
        var iconPath = window.logoMarkerIcon ? window.logoMarkerIcon : null;
        var markerOptions = {
            map: map,
            position: { lat: mapPoint.lat, lng: mapPoint.lng }
        };

        if (iconPath) {
            markerOptions.icon = iconPath;
        }
        var marker = new google.maps.Marker(markerOptions);
    }

    window.initMap = initMap;
});



//////////////////
// WEBPACK FOOTER
// ./LandingPageEntry.js
// module id = 1
// module chunks = 0 1